import {Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {MessageEnum, MessageIcon} from "@Common/neo-components/message/message-enum";
import {CustomMessageStyleModel} from "@Common/neo-components/message/custom-message-style.model";
import {MessageActionModel} from "@Common/neo-components/message/message-action.model";

@Component({
  selector: 'neo-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MessageComponent implements OnInit {
  @Input() dataCyId = 'default';
  @Input() message = '---';
  @Input() messageType: MessageEnum = MessageEnum.neutral;
  @Input() canHide = true;
  @Input() customMessageStyle = <CustomMessageStyleModel>{};
  @Input() messageActions: MessageActionModel[] = [];
  @Input() margin = '10px 10px 10px 10px';
  @Output() actionEvent = new EventEmitter<string|MessageActionModel>();
  isVisible = true;
  messageIcon: MessageIcon = MessageIcon.neutral;


  constructor() { }

  ngOnInit(): void {
    this.messageIcon = MessageIcon[this.messageType];
  }

  hide(): void {
    this.isVisible = false;
  }

  emitAction(action: MessageActionModel) {
    if(!action.disabled){
      if(action?.actionData){
        this.actionEvent.emit(action);
      }else{
        this.actionEvent.emit(action.actionIdentifier);
      }

    }
  }

}
